<div class="card">
    <div class="card-header">
      <h4>Customer Blocked List</h4>
    </div>
    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-10">
          <!--<button type="button" class="btn btn-primary " (click)="onBtnC($event)">Add Rows</button>-->
        
          <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="onExportCSV()">
            <i class="feather icon-download me-2"></i>Export Excel</button>
          <button type="button" class="btn bg-danger-custom" 
            (click)="quickFilterShowAction($event)"><i class="feather icon-filter me-2"></i>Quick Filters</button>
          <div class="btn-group mb-1 mb-md-0">
            <!--      <button type="button" class="btn bg-danger-custom">Columns</button>-->
            <div class="btn-group" ngbDropdown role="group">
              <button class="btn bg-danger-custom" ngbDropdownToggle><i class="feather icon-columns me-2"></i>Columns</button>
              <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                <div class="form-group">
                  <!--            <label for="columns" class="form-label"> All Columns</label>-->
                  <div *ngIf="columnDefs" class="list-group ng-option">
                    <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                      <label class="list-group-item p-2">
                        <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                          (change)="updateSelectedColumn($event)"
                          [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                        {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                      </label>
                    </span>
                  </div>
  
                </div>
                <!--          <ng-select-->
                <!--            [(ngModel)]="tableSelectedColumn"-->
                <!--            [closeOnSelect]="false"-->
                <!--            [items]="columnDefs"-->
                <!--            [multiple]=true-->
                <!--            bindLabel="field">-->
                <!--            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>-->
                <!--              <input [ngModel]="item$.selected" id="item-{{index}}" type="checkbox"/> {{item.field.toUpperCase()}}-->
                <!--            </ng-template>-->
                <!--          </ng-select>-->
  
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-xl-2" *ngIf="permissions.includes('View')">
          <input id="typeahead-basic" type="text" autocomplete="new-password" placeholder="Search in page"
            class="form-control" (selectItem)="searchQuickFilter($event)" [(ngModel)]="globalSearch"
            (ngModelChange)="onGlobalSearchChange($event)" [ngbTypeahead]="search" />
        </div> -->
      </div>
  
  
  
      
      <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      
  
        <div class="card">
          <div class="card-body">
            <div class="row">
          
              <!-- <div class="col-sm-4">
                <label class="col-form-label" for="customerMobile">Search By Fullname
                </label>
                    <input class="form-control" [(ngModel)]="fullName" type="text" autocomplete="new-password"
                     name="searchMerName" placeholder="Enter Fullname" id="searchMerName" (keyup)="allowAlfanumeric($event)" (keypress)="OnlyCharacterAllowed($event)">
              </div> -->


              <div class="col-sm-4">
                <label class="col-form-label" for="customerMobile">Search By Contact Number
                </label>
                    <input class="form-control" [(ngModel)]="mobileNumber" id="searchMID" placeholder="Enter Contact Number"
                    (focus)="fun('searchMID')" (focusout)="funover('searchMID')">
              </div>
<!-- 
              <div class="col-sm-4">
                <label class="col-form-label" for="customerMobile">Search By Email ID
                </label>
                    <input class="form-control" [(ngModel)]="emailId" id="customerMobile" type="text" autocomplete="new-password"
                     name="customerMobile" placeholder="Enter Email ID" >
              </div> -->

              <div class="col-sm-4 d-flex align-items-end">
                <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom me-2" type="button" style="width: 100%;">
                  <i class="feather icon-search me-2"></i>Search
                </button>
                <button (click)="resetFilter()" class="btn bg-secondary" type="button" style="width: 100%;">
                  <i class="feather icon-refresh-cw me-2"></i>Reset
                </button>
              </div>

            </div>
          </div>
        </div>
      
    </div>
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
            (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4 d-flex">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
          </select>
          <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
        </div>
  
        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
            [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
  
      </div>
    </div>
  
  </div>
  
  <!-- <app-modal #modalAdd [modalConfig]="modalConfigAdd">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
   <app-merchant-add (closeModal)="closeModalAdd($event)"></app-merchant-add>
  </app-modal> -->
  <!-- <app-modal #modalEdit [modalConfig]="modalConfigEdit">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
   <app-merchant-edit [editData]="modalConfigEdit"></app-merchant-edit>
  </app-modal> -->
  <!-- <app-modal #modalMerchant [modalConfig]="modalConfigMerchant">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
   <app-merchantriskconfig [merchantId]="Merchantdata" [onConfigChange]="merchantConfigEvent"></app-merchantriskconfig>
  </app-modal> -->
  <!-- <app-modal #modalMerchantBank [modalConfig]="modalConfigMerchant">
   &lt;!&ndash;  body of the modal  &ndash;&gt;
  <app-account-list [merchantId]="selectedMerchant" [onMerchantChange]="merchantSelectEvent" ></app-account-list>
  </app-modal> -->
  
  <app-modal #modalblokedCustomer [modalConfig]="modalConfigBlocked">
   
  <app-customer-blocked (closeModal)="closeModalBlocked($event)" [merchantStatusConfig]="tableInfo"
    [onMerchantMId]="BlockedmerchantSelectEvent">
  </app-customer-blocked> 
 <div>Delete </div> 
  </app-modal> 

  <app-modal #modalReportCustomer [modalConfig]="modalConfigReport" >

 

      <pdf-viewer 
          [src]="image"
          [rotation]="0"
          [original-size]="false"
          [show-all]="true"
          [fit-to-page]="false"
          [zoom]="1"
          [zoom-scale]="'page-width'"
          [stick-to-page]="false"
          [render-text]="true"
          [external-link-target]="'blank'"
          [autoresize]="true"
          [show-borders]="false"
          class="viewer">
</pdf-viewer>
    </app-modal> 
  